import React, { useRef, useState } from "react";
import { cloneDeep, merge } from "lodash";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@mui/material";

import FormRows from "./FormRows";
import { generateUUID, showToast } from "services/utils";
import { useNavigate } from "react-router";
import { Add } from "iconsax-react";
import DialogBox from "../Structure/DialogBox";
import { getRefValueByPath, setRefValueByPath } from "../services";

const CustomeForm = (props) => {
  const { userData, data } = props;
  const {
    columns = [],
    rows = {},
    config = {},
    isLoading = false,
    defaultValue = false,
  } = data;
  let defaultConfig = {
    defaultValue: false,
    // onDelete: {
    //     before: false,
    //     after: false,
    // },
    trackChanges: false,
    onDelete: false,
    // onSubmit: false,
    // addRow: false,
    // addRow: true,
    addRow: {
      isVisible: true,
      isActive: true,
    },
    // onSubmit: false,
    onSubmit: {
      checkESign: true,
      // type: "row",
      // type: "table",
      // handler: handleSubmit,
      handler: false,
      checkValidation: true,
      isVisible: true,
      isActive: true,
      // before : false,
      // after : false
      // before : {
      //     checkValidation : true,
      //     handler : (openFn) => { openFn() }
      // }
    },
    onESign: false,
    // onESign: {
    // isEsignDisable: false, enable or disable esign
    //     before: {
    //         checkValidation: true,
    //         handler: (handleModelOpen) => {
    //             handleModelOpen()
    //         }
    //     },
    //     // before: false,
    //     // afterESign: false,
    // },
    // validation: {
    //     beforeValidation: false,
    //     afterValidation: false,
    // },
    isDayOff: {
      uniqueName: false,
      isCheck: false,
    },
    // isStatic: true,
    isViewMode: false,
    multipleESign: false,
    // multipleESign: {
    //     format: ["first", "second"],
    //     // start : "second"
    //     start: 0
    // },
    // renderOptions : {
    //     specific : "rows", // all, rows, columns
    //     type : "single", // single
    // }
    // actions: [
    //     {
    //         tooltip : "View document",
    //         name: "view",
    //         icon: <Eye/>,
    //         color: "error",
    //         onClick: () => { },
    //         isVisible : false,
    //         isActive : true
    //     }
    // ],
    actions: false,
    renderOptions: false,
    dependencyFields: false,
    // dependencyFields: {
    //     endTime: {
    //         type: 'all',
    //         // effectOn: ["downTimeDuration"],
    //         // handler: (data) => { },
    //         handler: (data) => {
    //             /*
    //                 perforn any operation and return final value.
    //                 make sure the return value is same as column type
    //             */
    //             return ({
    //                 downTimeDuration: "18 : 20"
    //             })
    //         }
    //     }
    // },
    title: false,
    // title: {
    //     defaultTableName: "testTable",
    //     name: "Test Table",
    //     isVisible: true,
    // },
    chip: {
      // uniqueName: {
      //     color: "",
      //     varient: "",
      //     label: "",
      //     onClick: () => { }
      // },
      // reviewedBy: generateChipConfig
      // (data) => {
      //     /*
      //         clog data = {
      //             row,
      //             column,
      //         }
      //     */
      // }
    },
    navLink: false,
    // navLink: {
    //     breakdownReason: (data) => {
    //         return ({
    //             id : "684d37f7e7eb7998d2cd8b89"
    //         })
    //     }
    // },
    onScroll: false,
    dynamicOptions: false,
    // dynamicOptions: {
    //   //  uniqueName : [ ...options ],
    //   machineName: ["machine-11", "machine-22", "machine-33", "machine-44"],
    // }
  };

  defaultConfig = merge(defaultConfig, { ...config, userData });

  const [_, forceUpdate] = useState({});
  const render = () => forceUpdate({});
  let rowsErrorRef = useRef({});
  const ref = useRef();

  const hanlderRef = useRef({
    visibility: config?.hidden?.default,
    trackChanges: {},
    trackColumnChanges: [],
    structureModelStatus: false,
  });

  const renderRef = useRef({
    form: render,
    columnsRender: {},
  });

  const navigate = useNavigate();

  const checkValidation = () => {
    let errors = {};
    columns?.forEach((column) => {
      if (column?.isHeading) {
        return;
      }
      if (column?.validation && typeof column?.validation === "object") {
        const { required, msg, pattern, patternMsg } = column.validation;

        if (!required) return;

        if (
          (defaultConfig?.multipleESign !== false &&
            rows?.currentESignStep !== column?.eSignStep) ||
          column?.type === "esign" ||
          hanlderRef?.current?.visibility?.[column?.uniqueName]
        ) {
          return;
        }

        const value = rows?.[column?.uniqueName];
        let isValidValue = false;

        if (typeof value === "string") {
          isValidValue = value.trim().length > 0;
        } else if (Array.isArray(value)) {
          isValidValue = value.length > 0;
        } else if (value instanceof File || value instanceof Blob) {
          isValidValue = !!value.name || !!value.size;
        } else if (typeof value === "object" && value !== null) {
          isValidValue = Object.keys(value).length > 0;
        }

        if (!isValidValue) {
          errors[column?.uniqueName] = { error: true, msg };
          return;
        }

        if (pattern && typeof value === "string") {
          try {
            const parts = pattern.match(/^\/(.*)\/([gimsuy]*)$/);
            const regex = parts
              ? new RegExp(parts[1], parts[2] || "")
              : new RegExp(pattern);
            if (!regex.test(value)) {
              errors[column?.uniqueName] = {
                error: true,
                msg: patternMsg || "Invalid pattern",
              };
            }
          } catch (err) {
            console.error("Invalid regex pattern:", pattern, err);
          }
        }
      }
    });

    const hasErrors = Object.keys(errors).length > 0;
    rowsErrorRef.current = errors;
    if (hasErrors) renderRef.current.form();
    return !hasErrors;
  };

  const handleSubmit = () => {
    let isValidate = true;
    if (
      defaultConfig?.onSubmit !== false &&
      defaultConfig?.onSubmit?.checkValidation === true
    ) {
      isValidate = checkValidation();
    }
    if (!isValidate) {
      showToast("Error in table inputs !", false);
      return false;
    }

    let cloneDeepColumns = cloneDeep(columns),
      cloneDeepRows = cloneDeep(rows),
      cloneDeepTrackChanges = cloneDeep(hanlderRef.current?.trackChanges);

    cloneDeepTrackChanges = cloneDeepColumns?.forEach((field) => {
      if (field?.isAudit) {
        const key = field?.uniqueName;
        const value = cloneDeepRows[key];

        if (!(key in hanlderRef.current?.trackChanges)) {
          hanlderRef.current.trackChanges[key] = value;
        }
      }
    });

    if (!!defaultConfig?.trackChanges) {
      isValidate && defaultConfig?.onSubmit?.handler
        ? defaultConfig?.onSubmit?.handler(
            cloneDeep(cloneDeepRows),
            cloneDeep(hanlderRef.current.trackChanges)
          )
        : null;

      hanlderRef.current.trackChanges = {};

      return {
        rows: cloneDeep(cloneDeepRows),
        trackChanges: cloneDeep(hanlderRef.current.trackChanges),
      };
    } else {
      isValidate && defaultConfig?.onSubmit?.handler
        ? defaultConfig?.onSubmit?.handler(
            cloneDeep(cloneDeepRows),
            cloneDeep(hanlderRef.current.trackChanges)
          )
        : null;

      hanlderRef.current.trackChanges = {};

      return cloneDeep(cloneDeepRows);
    }
  };

  if (
    defaultConfig?.dynamicOptions !== false &&
    Object.keys(defaultConfig?.dynamicOptions || {}).length > 0
  ) {
    const dynamicOptionKeys = Object.keys(defaultConfig?.dynamicOptions);
    columns?.forEach((column) => {
      if (dynamicOptionKeys.includes(column?.uniqueName)) {
        column.options = defaultConfig?.dynamicOptions?.[column?.uniqueName];
      }
    });
  }

  const handleCancel = () => {
    if (typeof defaultConfig?.onCancel === "function") {
      defaultConfig.onCancel();
    } else if (defaultConfig?.onCancel?.handler) {
      defaultConfig.onCancel.handler();
    } else {
      navigate(-1);
    }
  };

  const hasEmptyValue = (obj) => {
    if (!obj || typeof obj !== "object") return true;
    if (Object.keys(obj).length === 0) {
      return false;
    }
    return Object.values(obj).some(
      (val) =>
        val === undefined ||
        val === null ||
        val === "" ||
        (typeof val === "object" && Object.keys(val).length === 0)
    );
  };

  if (!!defaultConfig?.onSubmit?.getSubmitHandler !== false) {
    defaultConfig?.onSubmit?.getSubmitHandler(handleSubmit, config);
  }

  const structureSubmit = () => {
    const {
      isActive = true,
      isVisible = true,
      handler = () => {},
    } = defaultConfig?.onSubmit;
    const finalColumns = columns?.map((col) => {
      const { uuid, ...other } = col;
      return other;
    });

    if (config?.wrapperSupport !== "on") {
      !!handler && typeof handler === "function" && handler(finalColumns);
      if (!!getRefValueByPath(hanlderRef, "structureModelStatus")) {
        setRefValueByPath(hanlderRef, "structureModelStatus", false);
        render();
        return;
      }
    }

    const trackColumnChanges = getRefValueByPath(
      hanlderRef,
      "trackColumnChanges"
    );
    const isChangeInLinkedKey = trackColumnChanges?.filter(
      (col) => !!col?.linkedKey
    );

    return {
      trackChanges: trackColumnChanges,
      columns: finalColumns,
      tableType: defaultConfig?.type,
      linkedKeyInTrackChange: isChangeInLinkedKey,
      rows: cloneDeep(rows),
    };
  };

  const finalConfig = {
    ...defaultConfig,
    hanlderRef,
    rows,
    columns,
    renderColumns: renderRef?.current?.columnsRender,
    renderForm: renderRef?.current?.form,
    trackChanges: hanlderRef?.current?.trackChanges,
  };

  props.data.config["GLOBAL_CONFIG"] = {
    config: finalConfig,
    SUBMIT_HANDLER: !!defaultConfig?.isStructure
      ? structureSubmit
      : handleSubmit,
  };

  const { wrapperUtils = {}, syncing = {} } = finalConfig?.wrapperConfig ?? {
    wrapperUtils: {},
    syncing: {},
  };

  return (
    <>
      <Box>
        {defaultConfig?.title?.isVisible && (
          <Box
            sx={{
              margin: "50px 0px 20px 0px",
            }}
          >
            <Typography variant="h5">{defaultConfig?.title?.name}</Typography>
          </Box>
        )}

        {!!defaultConfig.isStructure && (
          <DialogBox
            state={getRefValueByPath(hanlderRef, "structureModelStatus")}
            hanldeToggle={() => {
              setRefValueByPath(
                hanlderRef,
                "structureModelStatus",
                !getRefValueByPath(hanlderRef, "structureModelStatus")
              );
              render();
            }}
            hanldeNo={() => {
              setRefValueByPath(hanlderRef, "structureModelStatus", false);
              render();
            }}
            handleYes={() => {
              structureSubmit();
            }}
            data={finalConfig?.linkingData ?? []}
          />
        )}

        <TableContainer component={Paper} ref={ref}>
          <Table>
            {/* <TableBody> */}
            <FormRows
              columns={columns}
              rows={rows}
              config={finalConfig}
              errorRef={rowsErrorRef}
              helperFunction={{
                checkValidation,
                hasEmptyValue,
              }}
            />
            {/* </TableBody> */}
          </Table>
        </TableContainer>

        {!!defaultConfig?.isStructure && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "30px",
            }}
          >
            <Box>
              {(defaultConfig?.addRow?.isVisible === undefined
                ? true
                : !!defaultConfig?.addRow?.isVisible) && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    columns.push({
                      name: "",
                      uniqueName: "",
                      type: "text",
                      isNew: true,
                      uuid: generateUUID(),
                      // linkedKey: "fgbn "
                      // formatText : true
                    });
                    render();
                  }}
                  disabled={!defaultConfig?.addRow?.isActive}
                >
                  <Add />{" "}
                  <Typography sx={{ ml: "3px" }} variant="h6">
                    Add
                  </Typography>
                </Button>
              )}
            </Box>
            <Box>
              {!defaultConfig?.isViewMode &&
                !!defaultConfig?.isStructure &&
                (defaultConfig?.wrapperSupport === "on"
                  ? !syncing?.submits
                  : true) && (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                      const columnChangeTrack =
                        hanlderRef.current.trackColumnChanges;
                      const isChangeInLinkedKey = columnChangeTrack?.filter(
                        (col) => !!col?.linkedKey
                      );
                      if (isChangeInLinkedKey?.length > 0) {
                        setRefValueByPath(
                          hanlderRef,
                          "structureModelStatus",
                          true
                        );
                        render();
                        return;
                      }
                      structureSubmit();
                    }}
                    disabled={!defaultConfig?.onSubmit?.isActive}
                  >
                    Save
                  </Button>
                )}
            </Box>
          </Box>
        )}

        {!defaultConfig?.isViewMode &&
        !defaultConfig?.isStructure &&
        (!!defaultConfig?.wrapperSupport ? !syncing?.submits : true) ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
              my: "20px",
              gap: "20px",
            }}
          >
            {defaultConfig?.onCancel ? (
              <Button variant="contained" color="error" onClick={handleCancel}>
                Cancel
              </Button>
            ) : null}
            {defaultConfig?.onSubmit !== false &&
            defaultConfig?.onSubmit?.isVisible ? (
              <Button
                variant="contained"
                color="success"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            ) : null}
          </Box>
        ) : null}
      </Box>
    </>
  );
};

export default CustomeForm;
